import React from "react";
import { Link } from "react-router-dom";
import NavbarTwo from "../layout/Frontend/NavbarThree";
import Footer from "../layout/Frontend/NewFooter";
import { useState, useEffect } from "react";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ApiCalls from "../api/index";
const Constant = require("../helpers/constants");

export default function ContactUs() {
  const [alert, setAlert] = useState({ status: "", message: "" });
  const [messageSent, setMessageSent] = useState(false);
    let appOrigin = localStorage.getItem("appOrigin");

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        document.title = `Contact Us | ${ appOrigin == 'H' ? Constant.APP_NAME_DIRECT_HEALTH : appOrigin == 'N' ? Constant.APP_NAME_NEURODIVERSIFY : Constant.APP_NAME_GENERAL }`;
    }, []);

  const validationSchema = Yup.object().shape({
    enterprise_name: Yup.string()
      .trim()
      .required("Enterprise name is required"),
    full_name: Yup.string().trim().required("Full name is required"),
    email: Yup.string()
      .required("Please enter valid email address")
      .matches(Constant.EMAIL_REGEX, "Please enter valid email address"),
    phone: Yup.string().trim().required("Phone is required"),
    message: Yup.string().trim().required("Message is required"),
    acknowledgment: Yup.boolean().oneOf([true], "Acknowledgment is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isDirty },
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  const onSubmit = async (data) => {
    ApiCalls.post(`/api/v1/contact_us`, data).then((res) => {
      if (res) {
        setMessageSent(true);
        setAlert({ status: "success", message: res.data.message });
      } else {
        setAlert({ status: "error", message: res.data.message });
      }
    });
  };

  function SubmitButton() {
    if (!isDirty || !isValid) {
      return (
        <button
          type="submit"
          disabled
          className="btn model-post-disable-btn btn-disable outline-none btn-lg-lg_8x btn-primary btn-block"
        >
          Submit
        </button>
      );
    } else {
      return (
        <button
          type="submit"
          className="btn btn-lg-lg_8x btn-primary outline-none btn-block"
        >
          Submit
        </button>
      );
    }
  }

  return (
    <>
      <NavbarTwo />
      <div className="login_page container_bb">
        <div className="login_page_left">
          {process.env.REACT_APP_ORIGIN === "neurodiversify" ? (
            <img src="/beanbag-assets/img/neuro_login_ilustration.svg" alt="" />
          ) : (
            <img src="/beanbag-assets/img/login_ilustration.png" alt="" />
          )}
        </div>
        <div className="login_page_right">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div
              style={{ display: "none" }}
              className={`
                            ${
                              alert.status === "success"
                                ? "alert alert-success show"
                                : ""
                            }
                            ${
                              alert.status === "error"
                                ? "alert alert-danger show"
                                : ""
                            }`}
            >
              <span>{alert.message}</span>
            </div>
            {messageSent === false && (
              <>
                <h4>Contact Us</h4>
                <p>Please fill all the information</p>
                <div className="form-group">
                  <label htmlFor="">Enterprise Name</label>
                  <input
                    type=""
                    className={`form-control ${
                      errors.enterprise_name ? "is-invalid" : ""
                    }`}
                    {...register("enterprise_name")}
                    id="enterprise_name"
                    name="enterprise_name"
                    placeholder="Enter enterprise name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="">Full Name</label>
                  <input
                    type=""
                    className={`form-control ${
                      errors.full_name ? "is-invalid" : ""
                    }`}
                    {...register("full_name")}
                    id="full_name"
                    name="full_name"
                    placeholder="Enter full name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="">Email</label>
                  <input
                    type=""
                    className={`form-control ${
                      errors.email ? "is-invalid" : ""
                    }`}
                    {...register("email")}
                    id="email"
                    name="email"
                    placeholder="Enter email"
                  />
                  <span style={{ color: "red" }}>
                    {" "}
                    {errors.email && errors.email.message}
                  </span>
                </div>
                <div className="form-group">
                  <label htmlFor="">Phone Number</label>
                  <input
                    type=""
                    className={`form-control ${
                      errors.phone ? "is-invalid" : ""
                    }`}
                    {...register("phone")}
                    id="phone"
                    name="phone"
                    placeholder="Enter phone number"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="">Message</label>
                  <textarea
                    placeholder="Write a message"
                    className={`form-control ${
                      errors.message ? "is-invalid" : ""
                    }`}
                    {...register("message")}
                    name="message"
                    rows="8"
                    cols="80"
                  ></textarea>
                </div>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      className={`${errors.acknowledgment ? "is-invalid" : ""}`}
                      {...register("acknowledgment")}
                    />{" "}
                    I hereby acknowledge that the contact details are correct
                  </label>
                </div>
                <SubmitButton />
              </>
            )}
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
}
